import React from 'react';
import cn from "classnames";
import styles from "../../lib/global.css";

const PageContentMargin = props => (
    <div className={cn(styles.antLayoutContent, styles.sitedivContent, styles.pageContentMargin)}>
        <div style={{margin:"-8px -8px 8px"}}>
            {props.children}
        </div>
    </div>
);

export default PageContentMargin;
